































import { Component, Prop, Vue } from "vue-property-decorator";
import { Evidence, Match, Token } from "@/types";

@Component
export default class BaseToken extends Vue {
  @Prop() private value!: Token;

  @Prop() private matches!: Match[];

  @Prop() private id!: string;

  @Prop() private evidences!: Evidence[];

  private classes(obj: object, prefix: string): object {
    return [
      prefix,
      ...Object.entries(obj).map(([key, value]) => `${prefix}-${key}-${value}`)
    ];
  }
}
